"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  showInfo: false,
  showDebug: false,
  showWarn: true,
  showError: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/dist/config/logger-config.js
// module id = 880
// module chunks = 0